import axiosInstance from './axios';

export interface AuditLog {
    id: string;
    accion: string;
    entidad: string;
    entidadId: string;
    descripcion: string;
    ip: string;
    createdAt: string;
    usuario: {
        nombre: string;
        email: string;
        rol: string;
        companyId?: string;
        company?: {
            nombre: string;
        };
    };
}

export const getAuditLogs = async (): Promise<AuditLog[]> => {
    const response = await axiosInstance.get<AuditLog[]>('/audit');
    return response.data;
};
